import React, { FC } from 'react'

import { IconLandlineProps } from './IconLandline.types'
import * as Styled from './styles/IconLandline.style'

import { nonThemeableRules } from '../../ruleSet'

const IconLandline: FC<IconLandlineProps> = ({
  size = nonThemeableRules.defaultSize as number as IconLandlineProps['size'],
  isResponsive = false,
}: IconLandlineProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M14.16 26.531h-.7c-2.452 0-4.464 1.797-4.464 4v8.422c0 2.2 2 4 4.465 4h21.21c2.458 0 4.466-1.8 4.466-4v-8.422c0-2.203-2-4-4.465-4h-.7m-13.37-15.468h6.777c.887 0 1.605.718 1.605 1.605v6.8c0 .887-.718 1.606-1.605 1.606h-6.777a1.605 1.605 0 0 1-1.606-1.605v-6.801c0-.887.719-1.605 1.606-1.605Z'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M18.973 7c-2.211 0-4 1.79-4 4v24.074a4 4 0 0 0 4 4H29a4 4 0 0 0 4-4V7H18.973Z'
          stroke='#fff'
          strokeLinecap='round'
          strokeWidth='2'
        />
        <path d='M30.996 6.988V5.137' stroke='#fff' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path d='M20 25.082h8m-8 3.965h8m-8 3.965h8' stroke='#EA1A1A' strokeLinecap='round' strokeWidth='2' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconLandline
